export const UserRole = {
  Admin: 0,
  Editor: 1,
  User: 2
};

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;

//english lang
// export const defaultLocale = 'en'; 
// export const defaultLocaleDate = 'en-US'; 
// export const defaultCurrency = 'USD';
// export const defaultDirection = 'ltr';

// farsi lang
export const defaultLocale = 'fa';
export const defaultLocaleDate = 'fa-IR';
export const defaultCurrency = 'IRR';
export const defaultDirection = 'rtl';

export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'fa', name: 'Persian', direction: 'rtl' },
];

export const firebaseConfig = {
  apiKey: "AIzaSyBzl-5W5DoCGzNQAMb73CS2ZIm6egfCl8E",
  authDomain: "android-bf7b7.firebaseapp.com",
  projectId: "android-bf7b7",
  storageBucket: "android-bf7b7.appspot.com",
  messagingSenderId: "244875064109",
  appId: "1:244875064109:web:0fab11f7351909d19b59a4",
  measurementId: "G-ZKJRY3LK4Z"
};

export const currentUser = {
  id: 0,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const setCurrentUser = (name, image) => {
  currentUser.title = name;
  currentUser.img = image;
};

export const adminRoot = '/vazeh';
export const userRoot = '/user';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/pages/miscellaneous/search`;
export const servicePath = 'https://api.coloredstrategies.com';
export const baseURL =
  // 'https://beta.7030.ir/api';
  // 'https://dev.70si.ir/api';
'https://7030.ir/api';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.purplemonster';
export const isDarkSwitchActive = true;
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
